/**
 * Registry Dynamic Loader
 * Common dynamic loading template.
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'dynamic-loader';
const log = debug(MODULE_NAME);
//
// Dependencies
import {STATE, register, exists} from './index';
import toast from '@vendor/pyrsmk-toast/toast';
import isString from 'lodash/isString';

let staticPath = undefined;
const staticPathElement = document.querySelector('meta[name="site.paths.static"]');
if(staticPathElement) {
	staticPath = staticPathElement.content;
}



//
// Constants
const STATIC_PATH = staticPath;
const MANIFEST_FILE = STATIC_PATH + 'manifest.json';
let MANIFEST_FILE_DATA = undefined;
//
// Load

/**
 * Loads a module based on the existence of a selector.
 * @param {String} module - name of module to load (for registration)
 * @param {String} selector - selector to test for with document.querySelector
 * @param {Array} loadArray - array of assets to load (pass to toast.js)
 */
export default function dynamicLoader(module, selector, loadArray) {
	if (exists(module)) {
		log(`Module "${module}" already loaded. Exiting.`);
		return;
	}

	log(`Looking for selector "${selector}"`);
	let hasElements = !!document.querySelector(selector);

	if (!hasElements) {
		log('...no elements. Exiting.');
		register(module, STATE.NOT_REQUIRED);
		return;
	}

	readTextFile(MANIFEST_FILE, getManifestFileName, loadArray, module);
}

function getManifestFileName(text, loadArray, module) {
	var MANIFEST_FILE_DATA = JSON.parse(text);
	const resolvedLoadArray = loadArray.map((item) => {
		if (!isString(item)) {
			return item;
		}
		var newItem = item.replace('../', STATIC_PATH);		
		if (MANIFEST_FILE_DATA[newItem]) {
			return MANIFEST_FILE_DATA[newItem];
		}
		return newItem;
	});

	log(`Loading ${module} with assetArray`, resolvedLoadArray);
	toast.apply(null, resolvedLoadArray);
	
	register(module, STATE.LOADING);
}

function readTextFile(file, callback, loadArray, module) {
    var rawFile = new XMLHttpRequest();
    rawFile.overrideMimeType("application/json");
    rawFile.open("GET", file, true);
    rawFile.onreadystatechange = function() {
        if (rawFile.readyState === 4 && rawFile.status == "200") {
            return callback(rawFile.responseText, loadArray, module);
        }
    };
    rawFile.send(null);
}


// WEBPACK FOOTER //
// ./project/client/src/core/registry/dynamic-loader.js